import React, { useContext } from "react";
import ProgressBar from "react-bootstrap/ProgressBar";

import { PreferredLanguageContext } from "../../lib/main-context";
import { CREATE_ACCOUNT, PROGRESS } from "../../constants/HeaderTranslation";

const OnboardingProgress = ({ onboardingPercent }) => {
  const { language } = useContext(PreferredLanguageContext);
  return (
    <div className="flex items-center justify-between w-full">
      <h5 className="m-0 text-base md:text-lg">{CREATE_ACCOUNT[language]}</h5>

      <div className='text-sm md:text-base ml-auto mr-2'>
        {PROGRESS[language]}: {onboardingPercent}%
      </div>
      <ProgressBar
        now={onboardingPercent}
        max={100}
        variant="info"
        srOnly
        label={`Step ${onboardingPercent} / 100`}
      />
    </div>
  );
};

export default OnboardingProgress;
